import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';

const Navbar = () => {
  const location = useLocation();
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const navLinks = [
    { name: 'Home', href: '/' },
    { name: 'About Us', href: '/about' },
    { name: 'Courses', href: '/courses' },
    { name: 'Time Tables', href: '/timetables' },
    // { name: 'Gallery', href: '/gallery' },
    { name: 'Resources', href: '/resources' },
    { name: 'Feedback', href: '/feedback' },
    { name: 'FAQ', href: '/faq' },
  ];

  return (
    <nav className="fixed top-0 left-0 right-0 z-50 bg-white/90 backdrop-blur-md border-b border-slate-100 px-6 py-3 flex items-center justify-between shadow-sm">
      {/* Logo */}
      <Link to="/" className="flex items-center gap-2 cursor-pointer group">
        <div className="w-10 h-10 bg-gradient-to-br from-orange-500 to-red-600 rounded-lg flex items-center justify-center text-white font-bold text-xl shadow-lg shadow-orange-200 group-hover:scale-105 transition-transform">
          K
        </div>
        <div className="flex flex-col">
          <span className="font-bold text-slate-800 leading-tight">කසුන් වලකුඹුර</span>
          <span className="text-[10px] text-orange-600 font-bold tracking-widest uppercase">Education Center</span>
        </div>
      </Link>

      {/* Navigation Links - Centered */}
      <div className="hidden lg:flex items-center gap-8 absolute left-1/2 -translate-x-1/2">
        {navLinks.map((link) => {
          const isActive = location.pathname === link.href;
          return (
            <Link
              key={link.name}
              to={link.href}
              className={`font-medium transition-colors duration-200 ${isActive ? 'text-orange-600 font-bold drop-shadow-sm' : 'text-slate-600 hover:text-orange-600'}`}
            >
              {link.name}
            </Link>
          );
        })}
      </div>

      {/* Action Button */}
      <div className="flex items-center gap-4">
        <Link to="/login" className="hidden sm:block bg-gradient-to-r from-orange-500 to-red-600 hover:from-orange-600 hover:to-red-700 text-white px-6 py-2.5 rounded-lg font-bold transition-all shadow-md active:scale-95 shadow-orange-100">
          Login / Register
        </Link>
        {/* Mobile Toggle Placeholder */}
        <div 
          className="lg:hidden text-2xl text-slate-600 cursor-pointer"
          onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
        >
          {isMobileMenuOpen ? '✕' : '☰'}
        </div>
      </div>

      {/* Mobile Menu Dropdown */}
      {isMobileMenuOpen && (
        <div className="lg:hidden absolute top-full left-0 right-0 bg-white border-b border-slate-100 shadow-lg flex flex-col py-4 px-6 gap-4 z-40">
          {navLinks.map((link) => {
            const isActive = location.pathname === link.href;
            return (
              <Link
                key={link.name}
                to={link.href}
                onClick={() => setIsMobileMenuOpen(false)}
                className={`font-medium py-2 transition-colors duration-200 border-b border-slate-50 last:border-0 ${isActive ? 'text-orange-600 font-bold' : 'text-slate-600'}`}
              >
                {link.name}
              </Link>
            );
          })}
          <Link 
            to="/login" 
            onClick={() => setIsMobileMenuOpen(false)}
            className="text-center mt-2 bg-gradient-to-r from-orange-500 to-red-600 text-white px-6 py-3 rounded-lg font-bold shadow-md active:scale-95 shadow-orange-100"
          >
            Login / Register
          </Link>
        </div>
      )}
    </nav>
  );
};

export default Navbar;
